/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListChallenges } from "../funcs/accessListChallenges.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListChallengesResult } from "../models/components/listchallengesresult.js";
import {
  ListChallengesRequest,
  ListChallengesSecurity,
  QueryParamOutcome,
} from "../models/operations/listchallenges.js";
import { unwrapAsync } from "../types/fp.js";
export type ChallengesQueryData = ListChallengesResult;

export function prefetchChallenges(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListChallengesRequest | undefined,
  security?: ListChallengesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildChallengesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildChallengesQuery(
  client$: GramCore,
  request?: ListChallengesRequest | undefined,
  security?: ListChallengesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ChallengesQueryData>;
} {
  return {
    queryKey: queryKeyChallenges({
      outcome: request?.outcome,
      principalUrn: request?.principalUrn,
      scope: request?.scope,
      projectId: request?.projectId,
      resolved: request?.resolved,
      ids: request?.ids,
      from: request?.from,
      to: request?.to,
      limit: request?.limit,
      offset: request?.offset,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function challengesQueryFn(
      ctx,
    ): Promise<ChallengesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListChallenges(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyChallenges(
  parameters: {
    outcome?: QueryParamOutcome | undefined;
    principalUrn?: string | undefined;
    scope?: string | undefined;
    projectId?: string | undefined;
    resolved?: boolean | undefined;
    ids?: Array<string> | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    limit?: number | undefined;
    offset?: number | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listChallenges", parameters];
}
